$(function () {

    $('form:first').on('submit', function () {
        if ($(this).valid()) {
            $(this).find(':submit').attr('disabled', 'disabled');
        }
    });
});
